// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2mGWT","errorLogs":"EditorFooter_errorLogs__1KG2x"};